import type { TOC } from '@ember/component/template-only';
import { PrismIcon, PrismTooltip } from '@mylighthouse/prism-ember';
import type { IconName } from '@mylighthouse/prism-ember/types/components/prism/icon';

interface HotelMarketInsightTablesCellsTdCurrentPriceSignature {
  Args: {
    displayValue: {
      canShowFormattedCancellableText: boolean;
      formattedCancellableIcon: IconName;
      formattedRate: string;
      formattedRoomNameAndCancellableText: string;
    };
  };
}

const HotelMarketInsightTablesCellsTdCurrentPrice = <template>
  <div class="flex flex-row items-center justify-between gap-100">
    {{@displayValue.formattedRate}}

    {{#if @displayValue.formattedCancellableIcon}}
      <PrismIcon
        @name={{@displayValue.formattedCancellableIcon}}
        @size="extra-small"
      />
    {{/if}}
  </div>

  {{#if @displayValue.canShowFormattedCancellableText}}
    <PrismTooltip
      @side="right"
      @text={{@displayValue.formattedRoomNameAndCancellableText}}
    />
  {{/if}}
</template> satisfies TOC<HotelMarketInsightTablesCellsTdCurrentPriceSignature>;

export default HotelMarketInsightTablesCellsTdCurrentPrice;
